import { idEditTransform } from '../../../helpers/id-edit-transform'

export const contactIdEditTransform = idEditTransform(['domain'])
